import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';
import { useRef, useEffect } from 'react';

function useUnmount(func, { avoidStrictMode = false, useEffectFn = useEffect } = {}) {
  const funcRef = useRef(func);
  const avoidStricModeRef = useRef(avoidStrictMode);
  const strictTimeout = useRef();
  funcRef.current = func;
  avoidStricModeRef.current = avoidStrictMode;
  useEffectFn(() => {
    clearTimeout(strictTimeout.current);
    return () => {
      const { ENVIRONMENT } = getCompatEnv();
      if (avoidStricModeRef.current && ENVIRONMENT !== "production") {
        strictTimeout.current = window.setTimeout(() => {
          funcRef.current();
        }, 0);
      } else {
        funcRef.current();
      }
    };
  }, []);
}

export { useUnmount };
//# sourceMappingURL=useUnmount.js.map
